import type { AppLanguageCode } from '@/lib/i18n'
import { absoluteUrl } from '@/lib/site'

// ponytail: single shared social card; per-page OG images if a page ever needs its own.
const OG_IMAGE_PATH = '/og-image.png'

/**
 * Build the SEO head fragment (title, description, Open Graph, Twitter card,
 * canonical) for a public page. Call from a route `head` with the language
 * taken from `match.context.appLanguage`. Pass `path` as the route path so the
 * canonical URL and `og:url` stay absolute and stable.
 */
export function buildSeo(input: {
	appLanguage: AppLanguageCode
	path: string
	title: string
	description: string
}) {
	const url = absoluteUrl(input.path)
	const image = absoluteUrl(OG_IMAGE_PATH)

	return {
		meta: [
			{ title: input.title },
			{ name: 'description', content: input.description },
			{ property: 'og:type', content: 'website' },
			{ property: 'og:site_name', content: 'SeaLedger' },
			{ property: 'og:title', content: input.title },
			{ property: 'og:description', content: input.description },
			{ property: 'og:url', content: url },
			{ property: 'og:image', content: image },
			{
				property: 'og:locale',
				content: input.appLanguage === 'it' ? 'it_IT' : 'en_US'
			},
			{ name: 'twitter:card', content: 'summary_large_image' },
			{ name: 'twitter:title', content: input.title },
			{ name: 'twitter:description', content: input.description },
			{ name: 'twitter:image', content: image }
		],
		links: [{ rel: 'canonical', href: url }]
	}
}
